export enum ESessionTemplate {
  CHAT = 'solgari_chatactivity',
  CALL = 'solgari_call',
  HOME = 'solgari_calllist',
  NOTIFICATION = 'solgar_chat_notification',
}
